export const misMixins = {
    mounted() {
        this.getItem();
        this.getStatus();
        this.getStatusFinais();
        this.getTecnicos();
        this.getUnidades();
        this.getUnidadesExternas();
        
    },
    computed: {
        listtecnicos() {
            const pessoas = this.tecnicos;

            const map = pessoas.map((elem) => ({
                id: elem.id,
                value:
                    " <b>" +
                    elem.value.toUpperCase() +
                    "</b> - " +
                    elem.nome_unidade.toUpperCase(),
            }));
            return map;
        },
    },
    methods: {

        getUnidades() {
            this.loadingSearchUnidade = true;
            axios.get(`api/dashboard/unidades/get/externas`).then((response) => {
                this.unidades = response.data;
            }).finally(() => this.loadingSearchUnidade = false);
        },
        getUnidadesExternas() {
            this.loadingSearchUnidade = true;
            axios.get(`api/dashboard/unidades/get/externas/Filtrar(CRAS-OSC-SCFV)`).then((response) => {
                this.unidades = response.data;
            }).finally(() => this.loadingSearchUnidade = false);
        },
        submitFile(files) {
            this.files = files;
        },
        getStatus() {
            this.loadingStatus = true;
            axios.get(`api/dashboard/report/status/scfv`).then((response) => {
                this.status = response.data;
            }).finally(() => this.loadingStatus = false);;
        },
        verificarStatus(status) {
            this.statusAtual = status;

            if (this.statusAtual != this.statusAnterior) {
                const result = this.status_item.filter((item) => item.id == status);
                if (result[0].final == 1) {
                    //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                    this.$bvModal.show("status-historico-" + this.model);
                }
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/report/get/status/finais`, {
                    model: this.model,
                    module: "Scfv",
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        getTecnicos() {
            this.loadingTecnicos = true;
            axios
                .get(`api/dashboard/report/scfv/tecnicos/get`)
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .catch(() => {
                    this.loadingTecnicos = false;
                })
                .finally(() => {
                    this.loadingTecnicos = false;
                });
        },
    },
}
